import { brandCodeMap } from '@/constants';
import { comm } from './base';
import { base } from './base';
import { baseicLayout } from './UI/baseicLayout';
import { table } from './UI/table';
import { tabs } from './UI/tabs';
import { btn } from './UI/btn';
import { input } from './UI/input';
import { select } from './UI/select';
import { chartBox } from './UI/chartBox';
import { charts } from './UI/charts';
import { timeLine } from './UI/timeLine';
import { switchTh } from './UI/switch';
import { modal } from './UI/modal';
import { dataPicker } from './UI/dataPicker';
import { cascader } from './UI/cascader';
import { checkbox } from './UI/checkbox';

let componetThemes = {};
// 生成各品牌主题对象
componetThemes.comm = comm;
for (const item of Object.keys(brandCodeMap)) {
  componetThemes[item] = {
    ...base[item]?.others,
    ...baseicLayout[item],
    ...table[item],
    ...tabs[item],
    ...btn[item],
    ...input[item],
    ...select[item],
    ...chartBox[item],
    ...charts[item],
    ...timeLine[item],
    ...switchTh[item],
    ...modal[item],
    ...dataPicker[item],
    ...cascader[item],
    ...checkbox[item],
  };
}

/**
 * 全品牌主题，真正用到的主题文件
 */
export const themes = componetThemes;
